/**
 * Native payments-runtime swap endpoints. Base URL already includes `/api/v1` via HttpApiService.
 *
 * The legacy PHP endpoints this module used (`/utilities/countries`, `/utilities/wallets`,
 * `/utilities/quote`, `/swap`) are gone: quotes now come from `PaymentsQuotesService` and balances from
 * `PaymentsWalletsService`, both of which already exist for dispersions and wallets.
 */
export const SWAPS_API_ENDPOINTS = {
  SWAPS: "/internal/payments/swaps",
  byId: (id: string) => `/internal/payments/swaps/${id}`,
} as const;
